import mailTipsOOFTruncate from './mailTipsOOFTruncate';

const shouldTruncateOOFMessage = (oofMessage: string): boolean => {
    return mailTipsOOFTruncate(oofMessage).length !== oofMessage.length;
};

export default shouldTruncateOOFMessage;
